import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { approveBlockAccountRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList, blockAccountList, spamAccountList } from '../constants';

type useApproveBlockEmployerProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useApproveBlockEmployer = ({
    setAlertText = () => { },
}: useApproveBlockEmployerProps) => {
    const client = useQueryClient();

    const { mutate: approveBlockEmployer, isLoading: isApproveBlockEmployerLoading } =
        useMutation({
            mutationFn: (variables: {
                company_id: number | string;
            }) =>
                axiosInstance
                    .post(approveBlockAccountRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setAlertText(data.message);
                } else if (data.status === 200) {
                    client.invalidateQueries(adminEmployersList);
                    client.invalidateQueries(adminEnterprisesList);
                    client.invalidateQueries(spamAccountList);
                    client.invalidateQueries(blockAccountList);
                    setAlertText('');
                }
            },
            onError: () => {
                setAlertText(errorMessage);
            },
        });
    return {
        approveBlockEmployer,
        isApproveBlockEmployerLoading,
    };
};
